import React from 'react';
import { XIcon, MicIcon } from './icons';
import { HealthBuddy, BuddyMood } from './HealthBuddy';

/**
 * Bottom modal — the blueprint's primary deep-navigation mechanism.
 * Slides up over the current screen; the assistant stays visible in the
 * header (it is never "left behind").
 *
 * When `onBuddyTap` is provided, the header buddy becomes a control —
 * the Journey uses it as the voice-mode toggle. Subtle ring + mic badge
 * when active; the buddy mouths the audio while Sunny reads aloud and
 * ripples while listening.
 */
export function BottomModal({
  open,
  onClose,
  children,
  buddyMood = 'idle',
  maxHeight = '88%',
  onBuddyTap,
  buddyActive = false
}: {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  buddyMood?: BuddyMood;
  maxHeight?: string;
  onBuddyTap?: () => void;
  buddyActive?: boolean;
}) {
  if (!open) return null;
  return <div className="absolute inset-0 z-40" data-id="element-41">
      {/* backdrop — dims but keeps the app visible underneath */}
      <div className="dhp-fade absolute inset-0 bg-[#26312D66] backdrop-blur-[2px]" onClick={onClose} data-id="element-42" />

      {/* sheet */}
      <div className="dhp-rise absolute bottom-0 left-0 right-0 flex flex-col overflow-hidden rounded-t-[28px] bg-cream shadow-modal" style={{
      maxHeight
    }} data-id="element-43">
        {/* drag handle */}
        <div className="flex shrink-0 justify-center pb-1 pt-3" data-id="element-44">
          <div className="h-1.5 w-10 rounded-full bg-linen-deep" data-id="element-45" />
        </div>

        {/* assistant stays present */}
        <div className="absolute right-4 top-4 z-10 flex items-center gap-2" data-id="element-46">
          {onBuddyTap ? <button onClick={onBuddyTap} className={`relative rounded-full transition-all active:scale-90 ${buddyActive ? 'ring-2 ring-teal ring-offset-2 ring-offset-cream' : ''}`} data-id="element-47">
              <HealthBuddy size={34} mood={buddyMood} data-id="element-48" />
              {/* mic badge — the subtle "this is the voice toggle" affordance */}
              <span className={`absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full transition-colors ${buddyActive ? 'bg-teal text-cream' : 'bg-linen-deep text-ink-soft'}`} data-id="element-49">
                <MicIcon size={9} strokeWidth={2.4} data-id="element-50" />
              </span>
            </button> : <HealthBuddy size={34} mood={buddyMood} data-id="element-51" />}
          <button onClick={onClose} className="flex h-8 w-8 items-center justify-center rounded-full bg-linen text-ink-soft transition-colors hover:bg-linen-deep" data-id="element-52">
            <XIcon size={16} data-id="element-53" />
          </button>
        </div>

        <div className="overflow-y-auto overscroll-contain" data-id="element-54">{children}</div>
      </div>
    </div>;
}